var _g, _g2, _g3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgChinaIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "800px",
    height: "800px",
    viewBox: "0 0 64 64",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    "aria-hidden": "true",
    role: "img",
    className: "iconify iconify--emojione",
    preserveAspectRatio: "xMidYMid meet",
    fill: "#000000",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_bgCarrier",
    strokeWidth: 0
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_tracerCarrier",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_iconCarrier"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 32,
    cy: 32,
    r: 30,
    fill: "#f52439"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#ffe62e"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22 28.4l8 5.6l-3-9.2l8-5.8h-9.9L22 10l-3 9H9l8 5.8l-3 9.2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.3 35.3l-2.3.5l2.2.9V39l1.5-1.7l2.2.8l-1.3-1.9l1.4-1.8l-2.3.5l-1.4-1.9z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.7 28.5L37 30l2.3-.2l1 2.2l.4-2.3l2.3-.2l-2-1.2l.5-2.3l-1.7 1.5l-2-1.2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.3 20.7L40 23l.7-2.2H43l-1.8-1.4l.7-2.3l-1.9 1.4l-1.8-1.5l.7 2.3l-1.9 1.3z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.3 12.7V15l1.4-1.9l2.3.5l-1.4-1.8l1.3-1.9l-2.2.9L35.2 9v2.3l-2.2.9z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChinaIcon);
export default __webpack_public_path__ + "static/media/china-icon.6cd414d04ef1758c350d8ef2d1a1b062.svg";
export { ForwardRef as ReactComponent };